import Vue from 'vue'
import page from 'page'
import routes from './routes'
import VueScrollTo from 'vue-scrollto'

const app = new Vue({
  el: '#app',
  data: {
    ViewComponent: { render: h => h('div', 'loading...') }
  },
  render (h) { return h(this.ViewComponent) }
})
Vue.use(VueScrollTo)

//Object.keys(routes).forEach(route => {
  //page(route, () => app.ViewComponent = Component)
//page('/test', () => app.ViewComponent = require('./pages/Test.vue'))
page('/home', () => app.ViewComponent = require('./pages/Home.vue'))
page('/team', () => app.ViewComponent = require('./pages/Team.vue'))
page('/ensemble', () => app.ViewComponent = require('./pages/Ensemble.vue'))
page('/rhythm', () => app.ViewComponent = require('./pages/Rhythm.vue'))
page('/admin', () => app.ViewComponent = require('./pages/Admin.vue'))
page('/payment' , () => app.ViewComponent = require('./pages/Payment.vue'))
page('/payment_confirmation' , () => app.ViewComponent = require('./pages/Payment_confirm.vue'))
page('/ensaudition' , () => app.ViewComponent = require('./pages/PaymentEnsamble.vue'))
page('/rhyaudition' , () => app.ViewComponent = require('./pages/PaymentRhythm.vue'))
page('/detailstelaviv' , () => app.ViewComponent = require('./pages/DetailsRhythm.vue'))
page('/detailshaifa' , () => app.ViewComponent = require('./pages/DetailsRhythm.vue'))
page('/thankyoutelaviv' , () => app.ViewComponent = require('./pages/PaymentRhythm.vue'))
page('/thankyouhaifa' , () => app.ViewComponent = require('./pages/PaymentRhythm.vue'))
page('/thankyouadmin' , () => app.ViewComponent = require('./pages/PaymentRhythmAdmin.vue'))
//})
page('/team#gallery', () => page.redirect('/home#gallery'))
//page('*', () => page.redirect('/home'))
page('/repeat_questions', () => app.ViewComponent = require('./pages/RepeatQuestions.vue'))
page('/audition_questions', () => app.ViewComponent = require('./pages/AuditionTrialQuestions.vue'))
page('/subscription_request', () => app.ViewComponent = require('./pages/SubscriptionRequest.vue'))
page('/rhythm_manual', () => app.ViewComponent = require('./pages/RhythmManual.vue'))
page('/ensamble_manual', () => app.ViewComponent = require('./pages/EnsambleManual.vue'))

page()



// WEBPACK FOOTER //
// ./src/main.js